






import { Component, Vue } from "vue-property-decorator";
import AuditKebersihanAlatList from "@/components/ppi/audit-kebersihan-alat/AuditKebersihanAlatList.vue";

@Component({
  components: { AuditKebersihanAlatList }
})
export default class AuditKebersihanAlatPage extends Vue {}
